<template>
  <div
    class="inner"
    :class="{ swiping: isSwiping }"
    :style="{ transform: `translateY(${translateY}px)` }"
  >
    <SwipeWrapper
      @pan-start="handleSwipeDownStart"
      @pan-move="handleSwipeMove"
      @pan-end="handleSwipeDownEnd"
    >
      <div class="swipe"></div>
    </SwipeWrapper>
    <h2>Ура, подарки!</h2>
    <p class="main-message">
      Забронируйте столик в ресторанах-участниках через НАМТАМ впервые —
      получите сет настоек, вино или другой сюрприз. Количество подарков
      ограничено!
    </p>
    <div class="lottie-animation" ref="container"></div>
    <p class="bottom-message">
      *Акция действует только в ресторанах-участниках. Подарок предоставляется
      при первом бронировании через НАМТАМ и может отличаться в разных
      заведениях.
    </p>
    <VButton class="button" @click="closeModal">
      Список ресторанов и подарков
    </VButton>
    <IconPopupCross
      v-if="screenWidth !== 'mobile'"
      class="modal-cross"
      @click="closeModal"
      color="#fff"
    />
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import SwipeWrapper from "@/components/ui/SwipeWrapper.vue";
import VButton from "@/components/ui/VButton.vue";
import lottie from "lottie-web";
import animationData from "@/assets/json/lottie-animation/present.json";
import IconPopupCross from "@/components/icons/IconPopupCross.vue";

const container = ref(null);

const store = useStore();

const screenWidth = computed(() => {
  return store.getters.screenType;
});

const isSwiping = ref(false);
const translateY = ref(0);
const threshold = ref(100);

const closeModal = () => {
  window.open(
    "https://t.me/namtam_news_bot?utm_source=knopka_podarok&utm_medium=popup&utm_campaign=launch",
    "_blank"
  );

  store.dispatch("closeModal");
};

const handleSwipeDownStart = () => {
  isSwiping.value = true;
};

const handleSwipeDownEnd = () => {
  if (translateY.value > threshold.value) {
    closeModal();
  } else {
    translateY.value = 0;
    isSwiping.value = false;
  }
};

const handleSwipeMove = (event) => {
  if (event.deltaY > 0) {
    translateY.value = event.deltaY;
  }
};

onMounted(() => {
  lottie.loadAnimation({
    container: container.value,
    renderer: "svg",
    loop: true,
    autoplay: true,
    animationData,
  });
});
</script>

<style lang="scss" scoped>
.inner {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 550px;
  margin: auto;
  padding: 56px;
  background: linear-gradient(
    179.13deg,
    #f18e35 0.75%,
    #f690d3 57.7%,
    #b151ff 109.43%
  );
  border-radius: 8px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  color: #fff;

  @media screen and (max-width: 841px) {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    max-width: 100%;
    box-shadow: 0 -2px 10px 0 #0000000d;
    border-radius: 20px 20px 0 0;
    padding: 32px 24px 24px 24px;
  }

  &.swiping {
    transition: none;
  }
}

h2 {
  margin-bottom: 24px;

  font-weight: 700;
  font-size: 40px;
  line-height: 48px;
  text-align: center;

  @include mobile {
    margin-bottom: 16px;

    font-size: 32px;
    line-height: 40px;
  }
}

.main-message {
  width: 100%;
  margin-bottom: 24px;

  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  text-align: center;

  @include mobile {
    margin-bottom: 16px;

    font-size: 14px;
    line-height: 20px;
  }
}

.bottom-message {
  width: 100%;

  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;

  @include mobile {
    font-size: 12px;
    line-height: 16px;
  }
}

.button {
  height: 48px;
  margin-top: 24px;

  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
}

.modal-cross {
  position: absolute;
  top: 25px;
  right: 25px;
  cursor: pointer;
}

.swipe {
  display: none;

  @include mobile {
    display: block;
    position: absolute;
    width: 100%;
    height: 20px;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 16px 16px 0 0;
    background-color: #f18e35;

    &::before {
      content: "";
      left: 50%;
      position: absolute;
      top: 6px;
      transform: translate(-50%);
      width: 36px;
      height: 6px;
      border-radius: 4px;
      background-color: #d6d6d6;
    }
  }
}

.lottie-animation {
  width: 220px;
  height: 220px;
  margin: 0 auto;
  margin-bottom: 98px;

  @include mobile {
    margin-bottom: 24px;
  }
}
</style>
